import { render, staticRenderFns } from "./ShapoliContentLoader.vue?vue&type=template&id=0a622098&scoped=true&"
import script from "./ShapoliContentLoader.vue?vue&type=script&lang=ts&"
export * from "./ShapoliContentLoader.vue?vue&type=script&lang=ts&"
import style0 from "./ShapoliContentLoader.vue?vue&type=style&index=0&id=0a622098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a622098",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSkeletonLoader})
